module.exports = __webpack_public_path__ + "img/paint.383b6153.svg";